@if (isAuthenticated()) {
  <div class="flex h-screen flex-col bg-slate-50">
    <lib-header
      [items]="navItems()"
      [createItems]="createItems()"
      [logoUrl]="tenantLogoUrl()"
      [brandName]="tenantBrandName()"
      (logout)="onLogout()"
      (uploadRateFile)="onUploadRateFile()"
    />
    <main class="flex-1 overflow-y-auto p-6">
      <router-outlet />
    </main>
  </div>
} @else {
  <router-outlet />
}
